import {enableProdMode, ErrorHandler, importProvidersFrom} from '@angular/core';
import {environment} from './environments/environment';
import * as Sentry from '@sentry/angular-ivy';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/components/app.component';
import {NgForOf, NgIf, NgSwitch, NgSwitchCase} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {SpotlightProductsComponent} from './app/generic/component/products/spotlight.products.component';
import {SpotlightProductsWrapperComponent} from './app/generic/component/products/spotlight.products.wrapper.component';
import {HookParserEntry, provideDynamicHooks} from 'ngx-dynamic-hooks';
import {FilePondModule} from 'ngx-filepond';
import {ZXingScannerModule} from '@zxing/ngx-scanner';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {NgxPaginationModule} from 'ngx-pagination';
import {appRoutes} from './app/configuration/app.routing'
import {provideRouter, Router, withRouterConfig} from '@angular/router';
import {applicationServices} from './app/configuration/app.features';
import {genericDeclarations, genericImports, genericProviders} from './app/generic/configuration';

const componentParsers: Array<HookParserEntry> = [
	{
		component: SpotlightProductsWrapperComponent,
	},
	{
		component: SpotlightProductsComponent,
	},
];

if (environment.production) {
	enableProdMode();
}

if (environment.sentryEnvironment !== 'development') {
	Sentry.init({
		dsn: 'https://1788ecdd1d7544298f253d530a094bc7@sentry.eleven.nl/32',
		release: '13.10.0',
		environment: environment.sentryEnvironment,
		integrations: [
			Sentry.browserTracingIntegration()
		],
		tracesSampleRate: 0.5,
	});
}

bootstrapApplication(AppComponent, {
	providers: [
		importProvidersFrom(genericImports, NgxPaginationModule, AngularSvgIconModule.forRoot(), ZXingScannerModule, FilePondModule, ReactiveFormsModule, NgIf, NgSwitchCase, NgSwitch, NgForOf, genericDeclarations),
		provideDynamicHooks({parsers: componentParsers}),
		genericProviders,
		applicationServices,
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: Sentry.TraceService,
			deps: [Router],
		},
		provideRouter(appRoutes,
			withRouterConfig({
				onSameUrlNavigation: 'reload'
			}),
		)
	]
})
	.catch(err => console.error(err));
